import * as moment from 'moment';

export const colombia_holiday: any = require('colombia-holidays');

export const formatTime = (fecha)=>{
    const fechaFormat = moment(fecha).format('YYYY-MM-DD');
    console.log(fecha);
    return fechaFormat;
}

export const currentDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const time = `${year}-${(month <= 9) ? `0${month}` : month}-${(day <= 9) ? `0${day}` : day}`;
    return time;
}

export const myFilter = (d: moment.Moment): boolean => {
    // tslint:disable-next-line: max-line-length
    const dias_festivos: Array<string> = colombia_holiday.getColombiaHolidaysByYear(d.get('year')).map((festivo: {holiday: string, celebrationDay: string, celebration: string}) => festivo.holiday);
    const dia_actual = d.format('YYYY-MM-DD');
    const day = d.get('day');

    return dias_festivos.indexOf(dia_actual) == -1 && day !== 0 && moment(dia_actual).isSameOrAfter(moment().format('YYYY-MM-DD'));
}